import { useCallback, useEffect, useState } from 'react';
import {
  readMessageSoundsEnabled,
  setMessageSoundsEnabled,
  unlockMessageSound,
  writeMessageSoundsEnabled,
} from '../../../shared/notifications';

/** Mount once on Intervene page to satisfy browser autoplay policies. */
export default function useInterveneMessageSoundUnlock() {
  useEffect(() => {
    const unlock = () => {
      unlockMessageSound();
    };

    document.addEventListener('pointerdown', unlock, { once: true });
    document.addEventListener('keydown', unlock, { once: true });

    return () => {
      document.removeEventListener('pointerdown', unlock);
      document.removeEventListener('keydown', unlock);
    };
  }, []);
}

export function useInterveneMessageSoundPreference() {
  const [soundsEnabled, setSoundsEnabledState] = useState(() => readMessageSoundsEnabled());

  useEffect(() => {
    setMessageSoundsEnabled(soundsEnabled);
  }, [soundsEnabled]);

  const toggleSoundsEnabled = useCallback(() => {
    setSoundsEnabledState((prev) => {
      const next = !prev;
      writeMessageSoundsEnabled(next);
      setMessageSoundsEnabled(next);
      return next;
    });
  }, []);

  return {
    soundsEnabled,
    toggleSoundsEnabled,
  };
}
